import { FieldConfig, FieldRules, FieldRulesConfig } from '@/types/form'

export interface RoleFormState {
  name: string
  permissions: string[]
}

export const roleFields: (keyof RoleFormState)[] = ['name', 'permissions']

interface RoleFieldsConfig extends FieldConfig<{
  name: FieldRules<RoleFormState['name']>
  permissions: FieldRules<RoleFormState['permissions']>
}> {}

interface RoleFieldsConfigProps extends FieldRulesConfig<RoleFormState> {}

export function roleFieldsConfig(_props: RoleFieldsConfigProps): RoleFieldsConfig {
  return {
    fields: {
      name: {
        rules: {
          required: 'Role name is required',
        },
      },
      permissions: {
        rules: {
          required: 'At least one permission is required',
          validate: (val) => (val.length > 0 ? true : 'At least one permission is required'),
        },
      },
    },
  }
}
